// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.frosted-glass-container {
  position: relative;
  width: 60vw; /* Responsive width based on viewport */
  height: 25vh; /* Height responsive to viewport */
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: visible;
  border-radius: 10px;
}

.robot-icon {
  width: 100px; /* Fixed size for the robot */
  height: 100px; /* Fixed size */
  position: absolute;
  top: 50%;
  left: 0%; /* Start from the left */
  transform: translate(-100%, -50%); /* Peeking from the left */
  z-index: 0.5; /* Robot on top of the frosted glass */
  cursor: pointer;
}

.robot-icon img {
  width: 50%;
  height: 50%;
  object-fit: contain; /* Ensure image scales properly */
}

/* Frosted Glass */
.frosted-glass {
  width: 100%; /* Match the parent container */
  height: 100%; /* Match the parent container */
  background: rgba(0, 0, 0, 0); /* Frosted glass effect */
  -webkit-backdrop-filter: blur(20px);
          backdrop-filter: blur(20px);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2vw;
  z-index: 1; /* Behind the robot */
  border: 0.5px solid transparent;
  border-image: linear-gradient(to right, rgb(116, 112, 4), black) 1;
  border-radius: 10px;
}

.banner-text {
  color: white;
  font-size: 1vw; /* Responsive text size */
  font-weight: 300;
  text-align: left;
}

.stars-container {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 0; /* Ensure stars go behind the robot */
  overflow: hidden;
}

.star {
  position: absolute;
  border-radius: 50%;
}`, "",{"version":3,"sources":["webpack://./src/components/Homev2/RobotAnimation.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,WAAA,EAAA,uCAAA;EACA,YAAA,EAAA,kCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,mBAAA;AACJ;;AAEE;EACE,YAAA,EAAA,6BAAA;EACA,aAAA,EAAA,eAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA,EAAA,wBAAA;EACA,iCAAA,EAAA,0BAAA;EACA,YAAA,EAAA,sCAAA;EACA,eAAA;AACJ;;AAEE;EACE,UAAA;EACA,WAAA;EACA,mBAAA,EAAA,iCAAA;AACJ;;AAEE,kBAAA;AACA;EACE,WAAA,EAAA,+BAAA;EACA,YAAA,EAAA,+BAAA;EACA,4BAAA,EAAA,yBAAA;EACA,mCAAA;UAAA,2BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,UAAA,EAAA,qBAAA;EACA,+BAAA;EACA,kEAAA;EACA,mBAAA;AACJ;;AAEE;EACE,YAAA;EACA,cAAA,EAAA,yBAAA;EACA,gBAAA;EACA,gBAAA;AACJ;;AACE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA,EAAA,qCAAA;EACA,gBAAA;AAEJ;;AACE;EACE,kBAAA;EACA,kBAAA;AAEJ","sourcesContent":[".frosted-glass-container {\n    position: relative;\n    width: 60vw; /* Responsive width based on viewport */\n    height: 25vh; /* Height responsive to viewport */\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: visible;\n    border-radius: 10px;\n  }\n  \n  .robot-icon {\n    width: 100px; /* Fixed size for the robot */\n    height: 100px; /* Fixed size */\n    position: absolute;\n    top: 50%;\n    left: 0%; /* Start from the left */\n    transform: translate(-100%, -50%); /* Peeking from the left */\n    z-index: .5; /* Robot on top of the frosted glass */\n    cursor: pointer;\n  }\n  \n  .robot-icon img {\n    width: 50%;\n    height: 50%;\n    object-fit: contain; /* Ensure image scales properly */\n  }\n  \n  /* Frosted Glass */\n  .frosted-glass {\n    width: 100%; /* Match the parent container */\n    height: 100%; /* Match the parent container */\n    background: rgba(0, 0, 0, 0); /* Frosted glass effect */\n    backdrop-filter: blur(20px);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 2vw;\n    z-index: 1; /* Behind the robot */\n    border: .5px solid transparent;\n    border-image: linear-gradient(to right, rgb(116, 112, 4), black) 1;\n    border-radius: 10px;\n  }\n  \n  .banner-text {\n    color: white;\n    font-size: 1vw; /* Responsive text size */\n    font-weight: 300;\n    text-align: left;\n  }\n  .stars-container {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    z-index: 0; /* Ensure stars go behind the robot */\n    overflow: hidden;\n  }\n  \n  .star {\n    position: absolute;\n    border-radius: 50%;\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
